import React from 'react';
import { observer } from 'mobx-react-lite';
import { PagesGetType } from 'src/AppState/PagesState/PagesState';
import { useAppStateContext } from 'src/AppState/AppState';
import {
    ColumnOneOfTwoV2,
    MainContent,
    TwoColumnResponsiveContentReverse,
} from 'src/domains/layouts/shared/layout/Layout.style';
import { Header } from 'src/domains/layouts/shared/cms/header/header';
import { ListContainer } from 'src/domains/layouts/shared/cms/listV2/listItem/List.style';
import { ListItemPage } from 'src/domains/layouts/shared/cms/listV2/listItem/ListItemPage';
import { PagesFormV2 } from './PagesForm/PagesFormV2';

export const PagesV2 = observer(() => {
    const { pagesStateV2 } = useAppStateContext();

    return (
        <MainContent>
            <TwoColumnResponsiveContentReverse>
                <ColumnOneOfTwoV2>
                    <Header
                        title='Pages'
                        description='Pages refers to the pages within the accounts section, for example, About Us or FAQ’s.'
                    />

                    {pagesStateV2.isLoading === true ? (
                        <div
                            className='flex flex-col items-center justify-center flex-auto max-h-screen gap-6 p-6 bg-white font-tertiary flex-nowrap'
                            data-test=''
                        >
                            <div className='w-8 h-8 border-4 border-dashed rounded-full animate-spin border-foreground' />
                            <p className='m-0 text-sm text-foreground'>Loading questions list...</p>
                        </div>
                    ) : (
                        <ListContainer className='mt-6'>
                            {pagesStateV2.allPagesSorted !== null &&
                                pagesStateV2.allPagesSorted.map((page: PagesGetType | null) => {
                                    return page === null ? null : (
                                        <ListItemPage
                                            key={page.id}
                                            page={page}
                                        />
                                    );
                                })}
                        </ListContainer>
                    )}
                </ColumnOneOfTwoV2>

                <ColumnOneOfTwoV2>
                    <PagesFormV2 />
                </ColumnOneOfTwoV2>
            </TwoColumnResponsiveContentReverse>
        </MainContent>
    );
});

/* 
<LanguagesSelect
    selectOptions={languageState.languages}
    setAction={pagesStateV2.setFilterLanguage}
    value={pagesStateV2.filterLanguage}
/> */
